import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps } from '~src/app/utils/ConnectUtils';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

import { enterSpace } from '../../actions/spaces/EnterSpaceAction';
import { SiteSettingsSubspaceName, SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { ConnectedSiteSettingsSpace } from './SiteSettingsSpace';

export interface SpaceInfoProviderDispatchProps {
  readonly enterSpace: (spaceInfo: SpaceInfo) => void;
}

export interface SiteSettingsSpaceProviderOwnProps {
  readonly urls: SpacesSiteUrls;
  readonly siteName: string;
  readonly subspaceName: SiteSettingsSubspaceName;
}

export type SiteSettingsSpaceProviderProps = SiteSettingsSpaceProviderOwnProps & SpaceInfoProviderDispatchProps;

function SiteSettingsSpaceProvider(props: SiteSettingsSpaceProviderProps) {
  React.useEffect(() => {
    const enterSpace = props.enterSpace;
    const subspaceName = props.subspaceName;
    enterSpace({spaceType: 'sitesettings', subspaceName, item: SpaceItemForNonEntitySpace});
  }, [props.enterSpace, props.subspaceName]);

  return <ConnectedSiteSettingsSpace {...props} server={getSessionManagementServiceInstance()}/>;
}

const mapDispatchToProps: MapDispatchToProps<SpaceInfoProviderDispatchProps> = (dispatch) => bindActionCreators({
  enterSpace,
}, dispatch);

export const ConnectedSiteSettingsSpaceProvider: React.ComponentClass<SiteSettingsSpaceProviderOwnProps>
  = connect(null, mapDispatchToProps)(SiteSettingsSpaceProvider);
